import { Radio, RadioProps } from "@mantine/core";
import React, { useRef } from "react";
import { IFocusableFormField } from "@type";

export interface IFormRadioProps<Values = Record<string, unknown>>
  extends RadioProps,
    IFocusableFormField<Values> {}

export const FormRadio: <Values = Record<string, unknown>>(
  props: IFormRadioProps<Values>,
) => JSX.Element = ({ fieldName, parentForm, ...rest }) => {
  const elementRef = useRef<HTMLInputElement>(null);
  parentForm.registerField(fieldName, elementRef);
  return (
    <Radio
      {...parentForm.getInputProps(fieldName)}
      {...rest}
      ref={elementRef}
    />
  );
};
